import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IFileDownload, IExam, IExamCategory } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-export-questions',
  templateUrl: './export-questions.component.html',
  styleUrls: ['./export-questions.component.scss']
})
export class ExportQuestionsComponent implements OnInit {

  exportedFile: IFileDownload = {
    fileName: '',
    size: 0,
    extension: '',
    file: undefined
  };
  exam: IExam = examDefault;
  format = '';
  category = '';
  categoryList: IExamCategory[] = [];

  downloadnow = false;
  constructor(private popoverRef: PopoverRef<ExportQuestionsComponent>,
    private examService: ExamService, private snackBar: SnackbarService,) { }

  async ngOnInit() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];

      await this.examService.getExamCategories(this.exam.id).then((categories: any) => {
        this.categoryList = categories;
      });
    }

  }

  close() {
    this.popoverRef.close();
  }

  exportQuestion() {
    if (this.format == '') {
      this.snackBar.warning('Format Required')
      return;
    }

    this.examService.exportQuest(this.exam.id, this.format, this.category).then((s: IFileDownload) => {
      this.snackBar.success('Export Successfull')
      this.exportedFile = s;
      this.downloadnow = true;
    }).catch((e) => {
      // this.snackBar.open(e, 'Error', {
      //   duration: 3000,
      //   horizontalPosition: 'right', verticalPosition: 'top',
      // });

    });
  }

}
